import React, { useRef } from "react";
import { Carousel, Row, Col } from "antd";
import { BotonPrincipal } from "../componentes/btn";
import ipecus from "../img/home/productos/ipecus-blanco.svg";
import owltrack from "../img/home/productos/owltrack-blanco.svg";
import argefix from "../img/home/productos/argefix-blanco.svg";
import mundopiloto from "../img/home/productos/mundoPiloto-blanco.svg";
import neurolog from "../img/home/productos/neurolog-blanco.svg";
import productoNeurolog from "../img/home/productos/producto-neurolog.svg";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const productoIpecus = process.env.PUBLIC_URL + "/img/productos/producto-ipecus.svg";
const productoOwltrack = process.env.PUBLIC_URL + "/img/productos/producto-owltrack.svg";
const productoArgefix = process.env.PUBLIC_URL + "/img/productos/producto-argefix.svg";
const productoMundopiloto = process.env.PUBLIC_URL + "/img/productos/producto-mundoPiloto.svg";

export const CarouselProductos = () => {
  const carouselRef = useRef();

  return (
    <div style={{ position: "relative" }}>
      {/* Flecha izquierda personalizada */}
      <button
        className="custom-arrow custom-prev"
        onClick={() => carouselRef.current.prev()}
        aria-label="Anterior"
      >
        <LeftOutlined />
      </button>
      {/* Flecha derecha personalizada */}
      <button
        className="custom-arrow custom-next"
        onClick={() => carouselRef.current.next()}
        aria-label="Siguiente"
      >
        <RightOutlined />
      </button>
      <Carousel
        ref={carouselRef}
        autoplay
        dots={false}
        arrows={false} // Importante: arrows en false
      >
        {/* Slide logos */}
        <div className="carousel-slide" style={{ minHeight: "260px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <Row gutter={[32, 24]} align="middle" justify="center" style={{ marginBottom: "32px" }}>
              <Col xs={24} sm={12} md={8} lg={5} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://ipecus.com.ar/" target="_blank" rel="noopener noreferrer">
                  <img src={ipecus} alt="Logo Ipecus" className="image-marca logo-slide-principal" />
                </a>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://owl-track.com/" target="_blank" rel="noopener noreferrer">
                  <img src={owltrack} alt="Logo Owltrack" className="image-marca logo-slide-principal" />
                </a>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://www.argefix.ar/" target="_blank" rel="noopener noreferrer">
                  <img src={argefix} alt="Logo Argefix" className="image-marca logo-slide-principal" />
                </a>
              </Col>
            </Row>
            <Row gutter={[32, 24]} align="middle" justify="center" style={{ marginBottom: "32px" }}>
              <Col xs={24} sm={12} md={8} lg={5} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://mundopiloto.com.ar/" target="_blank" rel="noopener noreferrer">
                  <img src={mundopiloto} alt="Logo Mundo Piloto" className="image-marca logo-slide-principal" />
                </a>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://neurolog.com.ar/" target="_blank" rel="noopener noreferrer">
                  <img src={neurolog} alt="Logo NeuroLog" className="image-marca logo-slide-principal" />
                </a>
              </Col>
            </Row>
          </div>
        </div>

        {/* Slide Ipecus */}
        <div className="carousel-slide">
          <Row gutter={8} align="middle" justify="center" className="ant-row">
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={ipecus} alt="Producto Ipecus" className="image-marca" />
              <h5 className="subtitulos-principales-blancos">
                Gestión de hacienda <br />
                El software que tu campo necesita
              </h5>
              <br />
              <a href="https://ipecus.com.ar/" target="_blank" rel="noopener noreferrer">
                <BotonPrincipal text="Ir a Ipecus" colorFondo="#ffffff" colorTexto="#175E6A" />
              </a>
            </Col>
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={productoIpecus} alt="Producto Ipecus" className="carousel-image" />
            </Col>
          </Row>
        </div>

        {/* Slide Owltrack */}
        <div className="carousel-slide">
          <Row gutter={8} align="middle" justify="center">
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={owltrack} alt="Producto Owltrack" className="image-marca" />
              <h5 className="subtitulos-principales-blancos">
                Calculadora de huella de carbono <br />
                Una plataforma digital para una comunidad responsable
              </h5>
              <br />
              <a href="https://owl-track.com/" target="_blank" rel="noopener noreferrer">
                <BotonPrincipal text="Ir a Owltrack" colorFondo="#ffffff" colorTexto="#175E6A" />
              </a>
            </Col>
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={productoOwltrack} alt="Producto Owltrack" className="carousel-image" />
            </Col>
          </Row>
        </div>

        {/* Slide Argefix */}
        <div className="carousel-slide">
          <Row gutter={8} align="middle" justify="center">
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={argefix} alt="Producto Argefix" className="image-marca" />
              <h5 className="subtitulos-principales-blancos">
                Software para talleres mecánicos <br />
                Gestioná tu taller, ordená tu trabajo y el de tu equipo
              </h5>
              <br />
              <a href="https://www.argefix.ar/" target="_blank" rel="noopener noreferrer">
                <BotonPrincipal text="Ir a Argefix" colorFondo="#ffffff" colorTexto="#175E6A" />
              </a>
            </Col>
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={productoArgefix} alt="Producto Argefix" className="carousel-image" />
            </Col>
          </Row>
        </div>

        {/* Slide Mundo Piloto */}
        <div className="carousel-slide">
          <Row gutter={8} align="middle" justify="center">
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={mundopiloto} alt="Producto Mundo Piloto" className="image-marca" />
              <h5 className="subtitulos-principales-blancos">
                Solución App y Web para asociaciones<br />
                Plataforma digital para la gestión de competencias en el mundo del deporte motor
              </h5>
              <br />
              <a href="https://mundopiloto.com.ar/" target="_blank" rel="noopener noreferrer">
                <BotonPrincipal text="Ir a Mundo Piloto" colorFondo="#ffffff" colorTexto="#175E6A" />
              </a>
            </Col>
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={productoMundopiloto} alt="Producto Mundo Piloto" className="carousel-image" />
            </Col>
          </Row>
        </div>

        {/* Slide NeuroLog */}
        <div className="carousel-slide">
          <Row gutter={8} align="middle" justify="center">
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={neurolog} alt="Producto NeuroLog" className="image-marca" />
              <h5 className="subtitulos-principales-blancos">
                Software para consultorios <br />
                Solución todo en uno para profesionales
              </h5>
              <br />
              <a href="https://neurolog.com.ar/" target="_blank" rel="noopener noreferrer">
                <BotonPrincipal text="Ir a NeuroLog" colorFondo="#ffffff" colorTexto="#175E6A" />
              </a>
            </Col>
            <Col xs={24} sm={20} md={10} lg={8}>
              <img src={productoNeurolog} alt="Producto NeuroLog" className="carousel-image" />
            </Col>
          </Row>
        </div>
      </Carousel>
    </div>
  );
};